import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiListItemButton(theme: Theme): MuiThemeComponentOverride<"MuiListItemButton"> {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          // Selection (e.g. notifications list) — keep contrast on colored backgrounds.
          "&.Mui-selected": {
            "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
              color: "inherit",
            },
            color: theme.palette.primary.contrastText,
          },

          "&.active": {
            " *": { color: theme.palette.brand.white[100].main },
            backgroundColor: theme.palette.brand.blue[300].main,
          },

          borderRadius: "0.25rem",
        },
      },
    },
  };
}
